<template>
  <div class="col-12">
    <div class="col-12 q-my-lg">
      <adicionar-atividade
        :unidadeId="unidade.id"
        @atualizar="atualizarTodos"
      />
    </div>
    <div class="col-12 q-ml-sm">
      <p class="text-brand-5 text-weight-bold q-ml-md titulo-table">
        Atividades Atuais
      </p>
    </div>
    <div class="col-12">
      <q-table
        table-header-class="bg-accent text-weight-bold"
        :rows="listaAtividades"
        :columns="columns"
        :grid="$q.screen.lt.sm"
        v-model:pagination="pagination"
        :loading="loading"
        dense
        @request="handleRequest"
        hide-pagination
        flat
        color="primary"
        class="tabela-tamanho-fixo"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="row card q-mb-md">
              <div class="col-12 q-mr-sm q-mt-sm">
                <div
                  class="row text-brand-5 text-grid-table text-brand-5 q-pa-md"
                >
                  <div class="row col-12">
                    <span class="q-mr-xs"
                      ><strong>Nome Atividade:</strong>
                      {{ props.row.nome }}</span
                    >
                  </div>
                  <div class="row col-12">
                    <span class="q-mr-xs row items-center"
                      ><strong class="q-mr-xs">Atividade Crítica ?:</strong>
                      <div
                        v-if="props.row.critico"
                        class="elipse q-mr-sm bg-positive"
                      />
                      <div
                        v-if="!props.row.critico"
                        class="elipse q-mr-sm bg-red"
                      />
                      {{ props.row.critico ? "Sim" : "Não" }}</span
                    >
                    <span class="q-mr-xs row items-center"
                      ><strong class="q-mr-xs">Atividade Obrigatória ?:</strong>
                      <div
                        v-if="props.row.obrigatorio"
                        class="elipse q-mr-sm bg-positive"
                      />
                      <div
                        v-if="!props.row.obrigatorio"
                        class="row elipse q-mr-sm bg-red"
                      />
                      {{ props.row.obrigatorio ? "Sim" : "Não" }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="row col-12">
                <div class="column col-6">
                  <q-btn
                    label="Detalhe"
                    icon="add_circle"
                    stack
                    class="btn"
                    style="color: white; background: #3c76f1"
                    no-caps
                    @click="detalharAtividade(props.row.atividadeId)"
                  />
                </div>
                <div class="column col-6">
                  <q-btn
                    icon="delete"
                    stack
                    class="btn btn-remover-mobile"
                    no-caps
                    style="color: white; background: #cf1515"
                    @click="removerAtividade(props.row.atividadeId)"
                  />
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-detalhar="props">
          <q-td :props="props">
            <router-link
              :to="{
                name: 'pdt-atividade',
                params: {
                  unidadeId: unidade.id,
                  atividadeId: props.row.atividadeId,
                },
              }"
            >
              <q-btn color="white" text-color="blue" flat icon="add_circle" />
            </router-link>
          </q-td>
        </template>
        <template v-slot:body-cell-critico="props">
          <q-td :props="props">
            <div
              v-if="props.row.critico"
              class="row align items-center"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-positive" />
              <div style="width: fit-content" class="text-bold text-brand-5">
                {{ "Sim" }}
              </div>
            </div>
            <div
              v-else
              class="row align items-center"
              style="width: fit-content; background: #ffe9e9; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-red" />
              <div style="width: fit-content; color: #850202" class="text-bold">
                {{ "Não" }}
              </div>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-obrigatoria="props">
          <q-td :props="props">
            <div
              v-if="props.row.obrigatorio"
              class="row align items-center"
              style="width: fit-content; background: #e8ffec; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-positive" />
              <div style="width: fit-content" class="text-bold text-brand-5">
                {{ "Sim" }}
              </div>
            </div>
            <div
              v-else
              class="row align items-center"
              style="width: fit-content; background: #ffe9e9; padding: 2px 5px"
            >
              <span class="elipse q-mr-sm bg-red" />
              <div style="width: fit-content; color: #850202" class="text-bold">
                {{ "Não" }}
              </div>
            </div>
          </q-td>
        </template>

        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-4 text-weigth-bold" :props="props">
            {{ props.row.nome }}
          </q-td>
        </template>

        <template v-slot:body-cell-remover="props">
          <q-td :props="props">
            <q-btn
              color="white"
              text-color="red"
              flat
              no-caps
              icon="delete"
              @click="removerAtividade(props.row.atividadeId)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, watch, computed, ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import AdicionarAtividade from "./AdicionarAtividade.vue";
/* eslint-disable */
import router from "../../../../router";

export default {
  components: {
    AdicionarAtividade,
  },
  setup() {
    const columns = [
      {
        name: "nome",
        required: true,
        label: "Nome",
        align: "left",
        field: (row) => row.nome,
      },
      {
        name: "critico",
        align: "left",
        label: "Atividade Crítica?",
        field: "critico",
        sortable: true,
      },
      {
        name: "obrigatoria",
        align: "left",
        label: "Atividade Obrigatória?",
        field: "obrigatoria",
        sortable: true,
      },
      {
        name: "detalhar",
        label: "Detalhar",
        align: "center",
        field: "atividadeId",
        sortable: false,
      },
      {
        name: "remover",
        label: "Remover",
        align: "center",
        field: "atividadeId",
        sortable: false,
      },
    ];
    const unidade = ref("");
    const unidadeDetalhe = ref();
    const liberar = ref(true);
    const enviar = ref(0);

    const store = useStore();
    const quasar = useQuasar();

    const listaAtividades = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    const loading = ref(true);
    const disable = ref(false);

    const listarAtividades = async (page = 0, rowsPerPage = 6) => {
      const resposta = await store.dispatch("pdt/buscarDetalheUnidade", {
        unidadeId: unidade.value.id,
        perPage: rowsPerPage,
        page: page,
      });

      listaAtividades.value = resposta.data.resultado.dados;
      pagination.value.rowsPerPage = resposta.data.resultado.perPage;
      pagination.value.rowsNumber = resposta.data.resultado.total;
      pagination.value.page = resposta.data.resultado.currentPage;

      loading.value = false;
      disable.value = false;
    };

    const detalharAtividade = (atividadeId) => {
      router.push({
        name: "pdt-atividade",
        params: { unidadeId: unidade.value.id, atividadeId },
      });
    };

    const removerAtividade = async (atividadeId) => {
      await store.dispatch("pdt/removerAtividade", {
        unidadeId: unidade.value.id,
        atividadeId,
      });
      quasar.notify({
        message: "Atividade removida",
        color: "positive",
        actions: [
          {
            label: "fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      listarAtividades();
    };

    const handleRequest = async () => {
      listarAtividades(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        loading.value = true;
        handleRequest();
      }
    );

    const atualizarTodos = async () => {
      listarAtividades();
    };

    watch(unidade, () => {
      listarAtividades();
    });

    watch(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidade.value = store.state.org.unidadeData;
      listarAtividades();
    };

    onMounted(getUnidade);

    return {
      unidade,
      getUnidade,
      unidadeDetalhe,
      listarAtividades,
      listaAtividades,
      atualizarTodos,
      liberar,
      enviar,
      columns,
      removerAtividade,
      detalharAtividade,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      handleRequest,
      disable,
      loading,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
a {
  text-decoration: none;
}
.titulo-table {
  font-size: 18px;
}
@media (max-width: 600px) {
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn {
    border-radius: 0px;
    font-size: 11px;
  }
  .text-grid-table {
    font-size: 11px;
  }
  .elipse {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    padding: 0px;
    margin: -1px 5px 0px 0px;
  }
  .titulo-table {
    font-size: 14px;
    margin: 0px 0px 10px 0px;
  }
  .btn-remover-mobile {
    min-height: 45px !important;
  }
}

@media (max-width: 480px) {
  .btn-remover-mobile {
    min-height: 45px !important;
  }
}
</style>
